import { ChangeType } from "./changetracked";

export class RecordableAttachment {
    id: number;
    recordableId: number;
    file: File;
    byteArray: string;
    fileType: string;
    fileName: string;
    storageFilename: string;
    storageUri: string;
    storageSas: string;
    createdBy: string;
    createdUtcDate: Date;
    lastModifiedBy: string;
    lastModifiedUtcDate: Date;
    changeType: ChangeType;
    failed: boolean;
}